export const ADD_FLASH_MESSAGE = 'V2/FlashMessages/Add'
export const CLEAR_FLASH_MESSAGES = 'V2/FlashMessages/Clear'

export const addFlashMessage = (type, message, code?, url?) => ({
    type: ADD_FLASH_MESSAGE,
    payload: {
        type,
        message,
        code,
        url,
    },
})

export const clearMessages = () => ({ type: CLEAR_FLASH_MESSAGES })
